export function AuthDivider() {
  return <div className="gfg-auth-or">or continue with</div>;
}
